import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue'

import { Directive, DirectiveBinding, VNode } from 'vue'

export const appear: Directive = {
    beforeMount(element: HTMLElement) {
        element.style.visibility = 'hidden'
    },

    updated(
        element: HTMLElement,
        binding: DirectiveBinding<boolean>,
        node: VNode
    ) {
        if (!binding.value === !binding.oldValue || null === node.transition) {
            return
        }
        if (!binding.value) {
            node.transition.leave(element, () => {
                element.style.visibility = 'hidden'
            })
            return
        }
        node.transition.beforeEnter(element)
        element.style.visibility = ''
        node.transition.enter(element)
    },
}

createApp(App)
    .component('scroll-parallax', ScrollParallax)
    .use(router)
    .directive('appear', appear)
    .mount('#app')
